/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Barcos_Meta_TitleInputs */

const es_barcos_meta_title = /** @type {(inputs: Barcos_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alquileres y experiencias náuticas | Zarpar`)
};

const gl_barcos_meta_title = /** @type {(inputs: Barcos_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alugueiros e experiencias náuticas | Zarpar`)
};

const en_barcos_meta_title = /** @type {(inputs: Barcos_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boat rentals and experiences | Zarpar`)
};

/**
* | output |
* | --- |
* | "Boat rentals and experiences \| Zarpar" |
*
* @param {Barcos_Meta_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const barcos_meta_title = /** @type {((inputs?: Barcos_Meta_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Barcos_Meta_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_barcos_meta_title(inputs)
	if (locale === "en") return en_barcos_meta_title(inputs)
	return es_barcos_meta_title(inputs)
});